import { Container, Row, Col } from "react-bootstrap";
import "./video.css";

const Video = () => {
  return (
    <Container fluid>
      <Row>
        <Col md={6} className="red-bg pt-5 align-left">
          <h3>A WINNING ATTITUDE AND A FIERCE COMPETITIVE SPIRIT</h3>
          <p>
            Tamayo Cosentino Racing Team is a professional racing organization
            dedicated to achieving victory on the track. With a talented roster
            of drivers, top-notch equipment, and a relentless drive to succeed,
            Tamayo Cosentino is committed to winning at every race they enter.
            Whether it’s through hard work, determination, or cutting-edge
            technology, this team will stop at nothing in their quest to reach
            the top of the podium. With a winning attitude and a fierce
            competitive spirit, Tamayo Cosentino Racing Team is a force to be
            reckoned with in the world of motorsports.
          </p>
        </Col>
        <Col md={6} className="d-flex justify-content-center">
          <iframe
            className="bg-black"
            width="100%"
            height="500px"
            src="https://www.youtube.com/embed/LghKKPXkZVY"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
            allowfullscreen
          ></iframe>
        </Col>
      </Row>
    </Container>
  );
};

export default Video;
